export function logNewRelic(message: string, data: any, level: 'info' | 'error' = 'error') {
  if ('newrelic' in window) {
    (window.newrelic as any).log(message, {
      level,
      customAttributes: data,
    })
  }
}
